import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LightBoxComponent } from '../shared/light-box/light-box.component';
import { YeshivaLogoComponent } from '../shared/yeshiva-logo/yeshiva-logo.component';
import { YeshivaCaptionLogoComponent } from '../shared/yeshiva-caption-logo/yeshiva-caption-logo.component';
import { ShapeDividerComponent } from '../shared/shape-divider/shape-divider.component';
import { SmartRouterLinkComponent } from '../shared/smart-router-link/smart-router-link.component';
import { GlobalSearchComponent } from '../home/global-search/global-search.component';
import { GoogleTextAdComponent } from '../content/google-text-ad/google-text-ad.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        LightBoxComponent,
        YeshivaLogoComponent,
        YeshivaCaptionLogoComponent,
        ShapeDividerComponent,
        SmartRouterLinkComponent,
        GlobalSearchComponent,
        GoogleTextAdComponent,
    ],
    exports: [
        CommonModule,
        RouterModule,
        LightBoxComponent,
        YeshivaLogoComponent,
        YeshivaCaptionLogoComponent,
        ShapeDividerComponent,
        SmartRouterLinkComponent,
        GlobalSearchComponent,
        GoogleTextAdComponent,
    ],
})
export class EsiShellModule {}
